import { usePayment, useUser } from "@/stores/appStore";
import { UserTriggeredDialog } from "../guides/GuidesDialog";
import { cn } from "@/lib/utils";
import { Tip } from "../fun-ui/Tip";
import { MemberButton } from "../fun-ui/MemberButton";
import { VipLogoLightIcon } from "../fun-ui/icons";

export type ReceiveVipButtonProps = {
  collapsed?: boolean;
}

export const ReceiveVipButton = ({
  collapsed = false,
}: ReceiveVipButtonProps) => {
  const {
    receivePaymentVip
  } = useUser();
  const {
    setPaymentSuccessOpenWithTitle
  } = usePayment();
  return (
    <UserTriggeredDialog
      url="https://oss.findinai.cn/storage/20250706/1c47582c4e15f95b72b5c66ccb4fe8d7.jpeg"
      label="领取 Plus 会员"
      onDone={() => {
        (async () => {
          await receivePaymentVip();
          setPaymentSuccessOpenWithTitle('Plus 会员领取成功');
        })()
      }}
    >
      <div className={cn(
        "flex items-center",
        collapsed ? "justify-center p-2.5 px-2" : "px-4 py-2.5",
      )}>
        <Tip label={collapsed ? "领取 6 个月会员" : ""} side="right">
          <MemberButton
            size="sm"
            className={cn(
              "flex items-center gap-2 flex-1",
              collapsed ? "h-6 px-1.5" : "pl-1"
            )}
          >
            <VipLogoLightIcon size={collapsed ? 12 : 16} />
            {
              collapsed ? null : <span>领取 6 个月会员</span>
            }
          </MemberButton>
        </Tip>
      </div>
    </UserTriggeredDialog>
  )
}